import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import OurTeamService from './our-team.service.js';
import Seo from '../../infrastructure/seo.js';
import ScrollToTop from '../../shared/utils.js';

import './our-team.scss';

const labels = ['label-1', 'label-2', 'label-3', 'label-4'];
const historyLabels = [];

function random(min, max) {
	let rand = Math.round(min + Math.random() * (max - min));
	const anteriorValue = historyLabels[historyLabels.length - 1] % 2;
	let actualValue = rand % 2;

	if (historyLabels.length === 0) {
		historyLabels.push(rand);
		return rand;
	}

	while (anteriorValue === actualValue) {
		rand = Math.round(min + Math.random() * (max - min));
		actualValue = rand % 2;
	}

	historyLabels.push(rand);
	return rand;
}

const UserCard = ({ name, job, image }) => {
	const rand = random(0, 3);
	return (
		<section
			className=" col-lg-3 col-md-4 col-sm-6 col-xs-12"
		>
			<div className="card">
				  {image.path
				  && (
				  	<div
					className="image"
					style={{ backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT}/${image.path}')` }}
				  	/>
				  )}
				  {!image.path && (
					<div
						className="image noImage"
					/>
				)}
				<div className={`labels ${labels[rand]} `}>
					<div className="labels-info">
						<p className="label label-name">{name}</p>
						<p className="label label-job">{job}</p>
					</div>
				</div>
			</div>
		</section>);
};

class OurTeamPage extends Component {
	static prefetchOurTeamData = async language => OurTeamService.getEmployees(language);

	static prefetchOurTeamPageData = async language => OurTeamService.getPageData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.ourTeam || !this.props.ourTeamPageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (this.props.language.value !== prevProps.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		OurTeamPage.prefetchOurTeamData(this.props.language.value)
			.then((data) => {
				this.props.setOurTeam(data);
				OurTeamPage.prefetchOurTeamPageData(this.props.language.value)
					.then((res) => {
						this.props.setOurTeamPageData(res);
						this.props.setLoading(false);
					}).catch((error) => {
						this.props.setLoading(false);
						this.setState({
							hasError: true,
						});
						console.log(error);
					});
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const { ourTeam, ourTeamPageData, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !ourTeamPageData) {
			return <NotImplemented title="Our Team" />;
		}

		return (
			<section className="our-team-section">
				<Seo
					title={formatMessage({ id: 'navigation.about.team' })}
					description={(ourTeamPageData && ourTeamPageData.subtitle) ? ourTeamPageData.subtitle.replace(regex, '') : formatMessage({ id: 'navigation.about.team' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${ourTeamPageData && ourTeamPageData.title}",
											"description": "${ourTeamPageData && ourTeamPageData.subtitle.replace(regex, '')}",
											${ourTeam && `
												"about": [
													${ourTeam.map(item => `
														{
															"@type": "Person",
															"name": "${item.name}",
															"image": "${process.env.REACT_APP_API_ENDPOINT}${item.image.path}",
															"jobTitle": "${item.job}",
															"hasOccupation": {
																"@type": "Occupation",
																"name": "${item.job}"
															}
														}
													`)}
												]
											`}
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.team' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/our-team"
												}
											]
										}
									]
								}`}
				/>
				<div className="our-team container container-fluid">
					<div className="pageInfo">
						 <div className="title">{<span>{ourTeamPageData.title}</span>}</div>
						<div
							className="subTitle"
							dangerouslySetInnerHTML={{ __html: ourTeamPageData.subtitle }}
						/>
					</div>
					<div className="row  ">
						{ourTeam
						&& ourTeam.map(entry => <UserCard key={entry.id} {...entry} />)}
					</div>
				</div>
			</section>
		);
	}
}

const mapToProps = ({ language, ourTeam, ourTeamPageData, addresses, phones, generalData }) => ({
	language,
	ourTeam,
	ourTeamPageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(OurTeamPage));

export { OurTeamPage };
